/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry, Jeremy Levy
*/
import React, { useContext } from 'react';
import Block from '../../block/Block';
import useBrand from '../../hooks/use-brand';
import useCoreSettings from '../../hooks/use-core-settings';
import ThePrivateBankLogo from '../../icons/tpb-logo-icon/ThePrivateBankLogo';
import { getClasses } from '../../../lib/style-utils/style-utils';
import MastheadContext from '../MastheadContext';
import NavigationLogo from './NavigationLogo';
import TPBAnimatingNavigationLogo from './tpb-animating-navigation-logo/TPBAnimatingNavigationLogo';
import styles from './LogoBar.less';

var getInlineStyles = function getInlineStyles(_ref) {
  var screenSize = _ref.screenSize,
      responsive = _ref.responsive;

  if (responsive) {
    switch (screenSize) {
      case 'medium':
        return {
          padding: '0 17px'
        };

      case 'large':
      case 'xLarge':
        return {
          padding: '0 20px'
        };

      default:
        return {};
    }
  }

  return {};
};

var LogoBar = function LogoBar(_ref2) {
  var children = _ref2.children,
      handleClick = _ref2.handleClick,
      navigationDisabled = _ref2.navigationDisabled,
      logoAltText = _ref2.logoAltText;

  var _useCoreSettings = useCoreSettings(),
      useTPBBimUpdates = _useCoreSettings.useTPBBimUpdates;

  var _useContext = useContext(MastheadContext),
      screenSize = _useContext.screenSize,
      responsive = _useContext.responsive,
      device = _useContext.device;

  var brand = useBrand();

  var barClasses = function barClasses(_ref3) {
    var responsive = _ref3.responsive;
    return getClasses({
      styles: styles,
      classes: ['logoBar', responsive ? '' : 'yellow-border'],
      brand: brand,
      device: device
    });
  };

  var logoClasses = getClasses({
    styles: styles,
    classes: ['logo'],
    brand: brand
  });
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    flex: !responsive && !device.isMobile(),
    selfStretch: true,
    centered: true,
    className: barClasses({
      screenSize: screenSize,
      responsive: responsive
    }),
    style: getInlineStyles({
      screenSize: screenSize,
      responsive: responsive,
      device: device
    })
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    flex: true,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    center: true,
    className: logoClasses
  }, 'tpb' === brand && useTPBBimUpdates ? /*#__PURE__*/React.createElement(TPBAnimatingNavigationLogo, {
    handleClick: handleClick,
    navigationDisabled: navigationDisabled,
    logoAltText: logoAltText
  }) : /*#__PURE__*/React.createElement(NavigationLogo, {
    handleClick: handleClick,
    navigationDisabled: navigationDisabled,
    logoAltText: logoAltText
  })), 'tpb' === brand && !useTPBBimUpdates && /*#__PURE__*/React.createElement(Block, {
    layout: true,
    center: true,
    px: "s",
    className: styles.tpbLogo
  }, /*#__PURE__*/React.createElement(ThePrivateBankLogo, null)), children && /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    justifyEnd: true,
    flex: true,
    className: styles.buttons
  }, children)));
};

export default LogoBar;